import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

import { date } from 'src/lib/date/date';

function getFromToDates(days: number) {
  return { to: moment(), from: moment().subtract(days, 'days') };
}

export function useStatsVariables(days: number) {
  const [rangeMoments, setRangeMoments] = useState(() => getFromToDates(days));
  const { timeFrom, timeTo, resolution, pollInterval } = useMemo(
    () => date.getDateBounds('custom', rangeMoments),
    [rangeMoments],
  );
  useEffect(() => {
    const timeoutId = setTimeout(
      () => setRangeMoments(getFromToDates(days)),
      pollInterval,
    );
    return () => clearTimeout(timeoutId);
  }, [days, pollInterval]);
  return { timeFrom, timeTo, resolution };
}
